import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControlLabel,
} from "@material-ui/core";
import useStyles, { filterContainerHeight } from "../Styles";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { toolbarHeight } from "components/app/Styles";
import { useSelector } from "react-redux";
import userActions from "../actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import Checkbox from "@material-ui/core/Checkbox";
import CentralAZLocationFilter from "../CentralAZLocationFilter";
import { generateYearRange, xLabels } from '../utils'
import { useLocation } from "react-router";

const getWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};
const tabOptions = [
  { label: "State", value: 1 },
  { label: "Entity", value: 2 },
];

const AreaChart = () => {
  const classes = useStyles();
  const {
    toggle_about,
    city_selected,
    area_chart_tab,
    cities,
    entity_entitlements,
    priority_entitlements,
    scenario_selected,
    is_western,
    western_priority_entitlements,
    western_entity_entitlements,
    western_arizona_selected,
    western_arizona_entities,
  } = useSelector((state) => state.technical_view);
  const { loggedIn } = useSelector((state) => state.auth);
  const {
    setSelectedCity,
    setAreaChartTab,
    loadEntityEntitlements,
    loadCityMetrics,
    loadPriorityEntitlements,
    loadWesternArizonaPriorityEntitlements,
    loadWesternArizonaEntityEntitlements,
    setSelectedWesternArizonaEntity,
    setSelectedTribe,
    setIsCity,
    setIsWesternEntity,
    setIsTribe,
  } = userActions();
  const [windowSize, setWindowSize] = React.useState(getWindowSize());
  const [isPriority, setPriority] = useState(false);
  const [options, setOptions] = React.useState({});
  const { isMobile } = useGetViewPortDimensions();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dropdown = params.get('dropdown');

  // When undefined, value = 0 (placeholder).
  // Defined this instead of using setSelectedCity because location should be unslelected on State tab.
  const [, setSelectedLocation] = React.useState();

  const handleUrlParams = () => {
    if(dropdown && (cities?.length && western_arizona_entities?.length)) {
      let concatenatedEntities = [...cities, ...western_arizona_entities]
      var entityFound = concatenatedEntities.find((item) => item?.label?.toLowerCase() === (dropdown?.toLowerCase()));
      if(entityFound) {
        if(entityFound?.entity_type === 'Central') { 
          setSelectedCity(entityFound)
          setIsWesternEntity(false);
          setIsCity(true);
          setIsTribe(false);

          loadEntityEntitlements(entityFound?.value, scenario_selected?.value);
        } else {
          setSelectedWesternArizonaEntity(entityFound);
          setIsWesternEntity(true);
          setIsCity(false);
          setIsTribe(false);

          loadWesternArizonaEntityEntitlements(entityFound?.value, scenario_selected?.value)
        }
      }
    }
  }
  /** Set the entity value on page load */
  useEffect(handleUrlParams, [dropdown, cities, western_arizona_entities])


  React.useEffect(() => {
    setSelectedLocation(city_selected.city_id);
  }, [city_selected]);

  const loadData = () => {
    loadPriorityEntitlements(scenario_selected.value);
    loadEntityEntitlements(city_selected.city_id, scenario_selected.value);
    loadWesternArizonaPriorityEntitlements(scenario_selected.value);
    loadWesternArizonaEntityEntitlements(western_arizona_selected.entity_id, scenario_selected.value);
  }
  React.useEffect(loadData, [scenario_selected]);

  // Currently not used
  // const onChangeSelectedLocation = (e) => {
  //   const value = e.target.value;
  //   const city = cities.filter((item) => item.value == value)[0];
  //   setSelectedLocation(value);
  //   setSelectedCity(city); // city_selected is used on AboutTab
  //   loadEntityEntitlements(value);
  // };

  const onChangeTab = (event, value) => {
    const target = tabOptions.filter((item) => item.value === value)[0];
    setAreaChartTab(target);
    // Also change selected location
    if (value === tabOptions[0].value) {
      // When tab "State" is selected
      setPriority(false);
    } else if (value === tabOptions[1].value) {
      // When tab "Entity" is selected
      setSelectedLocation(city_selected.city_id);
    }
  };

  const onChangeCheckbox = (event) => {
    const checked = event.target.checked;
    setPriority(checked);
  };

  //gets windowSize to set width of barchart
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const setOptionHook = () => {
    if (!(area_chart_tab.value===2 && is_western && Object.keys(western_entity_entitlements).length === 0)){
      const new_options = createOptions(
        area_chart_tab,
        priority_entitlements,
        city_selected,
        entity_entitlements,
        western_priority_entitlements,
        western_entity_entitlements,
        is_western,
        isPriority,
        windowSize,
        isMobile,
        toggle_about
      );
      setOptions(new_options);
    }
  }
  useEffect(setOptionHook, [
    area_chart_tab,
    isPriority,
    city_selected,
    entity_entitlements,
    priority_entitlements,
    western_priority_entitlements,
    western_entity_entitlements,
    is_western,
    toggle_about,
    windowSize,
  ]);

  const handleChange = (value) => {
    loadCityMetrics(value);
    setSelectedCity(cities[value - 1]);
    loadEntityEntitlements(value, scenario_selected.value);
  };

  return (
    <>
      {/* This is only for the PUBLIC VIEW */}
      {!loggedIn && (
        <Box sx={{ pl: 8 }}>
          <CentralAZLocationFilter
            location_options={cities}
            handleChange={handleChange}
            isCurrentTabCitites={true}
            chart_name="water_use_versus_access"
            dropdown="phoenix"
          />
        </Box>
      )}

      <Box>
        <Grid>
          <Grid item xs={12} className={classes.tabs} style={{ marginTop: 0 }}>
            <Tabs
              value={area_chart_tab.value}
              onChange={onChangeTab}
              classes={{
                root: classes.tabRoot,
                indicator: classes.tabIndicator,
              }}
            >
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value={tabOptions[0].value}
                label={tabOptions[0].label}
                className={classes.startingTabAreachart}
              ></Tab>
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value={tabOptions[1].value}
                label={tabOptions[1].label}
                className={classes.endingTabAreachart}
              ></Tab>
            </Tabs>
          </Grid>
          {area_chart_tab.value === 2 && !is_western? (
            <Grid item xs={7} className={classes.areachartSEarchLocation}>
              <FormControlLabel
                control={<Checkbox color="primary" />}
                className={classes.priorityCheckboxLabel}
                label="Show by priority"
                onChange={onChangeCheckbox}
              />
            </Grid>
          ) : (
            <Grid item xs={7}>
              <div style={{ height: 42 }} />
            </Grid>
          )}
          <Grid item xs={4} />
        </Grid>
        <Box className={classes.highchart}>
          
          {
            area_chart_tab.value===1 || (area_chart_tab.value===2 && !is_western) || (area_chart_tab.value===2 && Object.keys(western_entity_entitlements).length !== 0)?
            (
              <HighchartsReact highcharts={Highcharts} options={options} />
            ): (
              "Results coming soon"
            )
          }
          {/* <HighchartsReact highcharts={Highcharts} options={options} /> */}

          
        </Box>
      </Box>
    </>
  );
};

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: "Arial",
      fontSize: "14px",
    },
  },
});

const createOptions = (
  area_chart_tab,
  priority_entitlements,
  city_selected,
  entity_entitlements,
  western_priority_entitlements,
  western_entity_entitlements,
  is_western,
  isPriority,
  windowSize,
  isMobile,
  toggle_about,
) => {
  let series, data;
  const year_list = generateYearRange();
  const priority_names_map = {
    nia_priority_contract_entitlement: "NIA",
    indian_priority_contract_entitlement: "Indian",
    mi_priority_contract_entitlement: "M&I",
    p13_contract_entitlement: "P2, P3 & PWM",
    dcp_nia_contract_entitlement: "DCP NIA",
    leases_exchanges: "Leases & Exchanges",
  };

  let state_tab_series = [
    {
      name: "Central Arizona",
      data: [],
      color: "#6AA4DC",
      marker: {
        lineColor: "#FFFFFF",
        lineWidth: 1.5,
        symbol: "diamond",
        radius: 4,
      },
      lineColor: "#FFFFFF",
    },
    {
      name: "Western Arizona",
      data: [],
      color: "#2352D0",
      marker: {
        lineColor: "#FFFFFF",
        lineWidth: 1.5,
        symbol: "circle",
        radius: 4,
      },
    },
  ];

  let entity_tab_series = [
    {
      name: "",
      data: [],
      color: "#6AA4DC",
      lineColor: "#6AA4DC",
      marker: {
        lineColor: "#FFFFFF",
        lineWidth: 1.5,
        symbol: "diamond",
        radius: 4,
      },
    },
  ];

  let priority_series = [
    {
      name: "NIA",
      data: [],
      color: "#2352D0",
      lineWidth: 0.7,
      marker: {
        lineColor: "#FFFFFF",
        lineWidth: 0.7,
        symbol: "circle",
        radius: 4,
      },
      lineColor: "#000000",
    },
    {
      name: "Indian",
      data: [],
      color: "#6AA4DC",
      lineWidth: 0.7,
      marker: {
        lineColor: "#000000",
        lineWidth: 0.7,
        symbol: "diamond",
        radius: 4,
      },
      lineColor: "#000000",
    },
    {
      name: "M&I",
      data: [],
      color: "#FFB607",
      lineWidth: 0.7,
      marker: {
        lineColor: "#000000",
        lineWidth: 0.7,
        symbol: "square",
        radius: 4,
      },
      lineColor: "#000000",
    },
    {
      name: "P2, P3 & PWM",
      data: [],
      color: "#D88C31",
      lineWidth: 0.7,
      marker: {
        lineColor: "#000000",
        lineWidth: 0.7,
        symbol: "triangle",
        radius: 4,
      },
      lineColor: "#000000",
    },
    {
      name: "DCP NIA",
      data: [],
      color: "#DE3E40",
      lineWidth: 0.7,
      marker: {
        lineColor: "#000000",
        lineWidth: 0.7,
        symbol: "triangle-down",
        radius: 4,
      },
      lineColor: "#000000",
    },

    {
      name: "Leases & Exchanges",
      data: [],
      color: "#96D9E4",
      lineWidth: 0.7,
      marker: {
        lineColor: "#000000",
        lineWidth: 0.7,
        symbol: "circle",
        radius: 4,
      },
      lineColor: "#000000",
    },
  ];

  // Initialization ------------------------
  let initial_data = [];
  year_list.map((year) => {
    initial_data.push(0);
    return year
  });

  state_tab_series[0].data = initial_data;
  state_tab_series[1].data = initial_data;

  entity_tab_series[0].data = initial_data;

  priority_series[0].data = initial_data;
  priority_series[1].data = initial_data;
  priority_series[2].data = initial_data;
  priority_series[3].data = initial_data;
  priority_series[4].data = initial_data;
  // Initialization ------------------------

  if (area_chart_tab.value === 1) {
      // State tab
      // central AZ data
      if (Object.keys(priority_entitlements).length > 0) {

        data = [];
        let total = 0;
        let root_key;

        year_list.map((year) => {
          total = 0;
          Object.keys(priority_names_map).map((priority) => {
            if (priority_entitlements[year] !== undefined) {
              root_key = Object.keys(priority_entitlements[year])[0]
              if (priority in priority_entitlements[year][root_key]) {
                total += priority_entitlements[year][root_key][priority]
              }

            }
            return priority
          })
          data.push(total)
          return year
        })
        state_tab_series[0].data = data; // state_tab_series[0] contains data for Central Arizona
      }

      // western AZ data (TODO: this is placeholder data until we get actual data from model)
      // state_tab_series[0].data = [
      //   1102609, 1095947, 1092994, 1090042, 1084137, 1078233, 1072328, 1066424,
      //   1060519, 1054614,
      // ].map((item, idx) => {
      //   if (idx <= 4) {
      //     return item;
      //   } // extract the first 5 years (2022 - 2026)
      // });

      if (Object.keys(western_priority_entitlements).length > 0) {
        data = [];
        year_list.map((year) => {
          data.push(western_priority_entitlements[year]);
          return year
        });
        state_tab_series[1].data = data; // state_tab_series[1] contains data for Western Arizona
      }
      series = state_tab_series;
  } else if (isPriority === false) {
    // Entity tab without priority
    let name;
    if (!is_western){
      name = entity_entitlements[year_list[0]]?.entity_name;
      data = year_list.map((year) => {
        if (entity_entitlements[year]) {
          return entity_entitlements[year].total_co_access;
        }
        return 0;
      });
      entity_tab_series[0].data = data;
      entity_tab_series[0].name = name;
    }
    else{
      name = western_entity_entitlements[year_list[0]].entity_name;
      data = year_list.map((year) => {
        if (western_entity_entitlements[year]) {
          return western_entity_entitlements[year].total_supply;
        }
        return 0;
      });
      entity_tab_series[0].data = data;
      entity_tab_series[0].name = name;
    }
    
    series = entity_tab_series;
  } else {
    // Entity tab with priority
    if (!is_western){
      let priority_name = Object.keys(priority_names_map);

      priority_name.map((priority, idx) => {
        data = [];
        year_list.map((year) => {
          let priorities =
            entity_entitlements[year].indivisual_priority_entitlements;
          if (priority in priorities) {
            data.push(priorities[priority]);
          }
          return year
        });
        priority_series[idx].data = data;
        return priority
      });
      series = priority_series;
    }
    else{
      let western_priority_series = [
        {
          name: "",
          data: [],
          color: "#2352D0",
          lineWidth: 0.7,
          marker: {
            lineColor: "#FFFFFF",
            lineWidth: 0.7,
            symbol: "circle",
            radius: 4,
          },
          lineColor: "#000000",
        },
        {
          name: "",
          data: [],
          color: "#6AA4DC",
          lineWidth: 0.7,
          marker: {
            lineColor: "#000000",
            lineWidth: 0.7,
            symbol: "diamond",
            radius: 4,
          },
          lineColor: "#000000",
        },
        {
          name: "",
          data: [],
          color: "#FFB607",
          lineWidth: 0.7,
          marker: {
            lineColor: "#000000",
            lineWidth: 0.7,
            symbol: "square",
            radius: 4,
          },
          lineColor: "#000000",
        },
        {
          name: "",
          data: [],
          color: "#D88C31",
          lineWidth: 0.7,
          marker: {
            lineColor: "#000000",
            lineWidth: 0.7,
            symbol: "triangle",
            radius: 4,
          },
          lineColor: "#000000",
        },
        {
          name: "",
          data: [],
          color: "#DE3E40",
          lineWidth: 0.7,
          marker: {
            lineColor: "#000000",
            lineWidth: 0.7,
            symbol: "triangle-down",
            radius: 4,
          },
          lineColor: "#000000",
        },
    
        {
          name: "",
          data: [],
          color: "#96D9E4",
          lineWidth: 0.7,
          marker: {
            lineColor: "#000000",
            lineWidth: 0.7,
            symbol: "circle",
            radius: 4,
          },
          lineColor: "#000000",
        },
      ];
    
      let priority_name = Object.keys(western_entity_entitlements[year_list[0]]["priorities"]);
      priority_name.map((priority, idx) => {
        western_priority_series[idx].name = priority;
        return priority
      });
      western_priority_series = western_priority_series.slice(0,priority_name.length);
      priority_name.map((priority, idx) => {
        data = [];
        year_list.map((year) => {
          let priorities =
            western_entity_entitlements[year].priorities;
          if (priority in priorities) {
            data.push(priorities[priority]);
          }
          return year
        });
        western_priority_series[idx].data = data;
        return priority
      });
      series = western_priority_series;
    }
    
  }

  return {
    chart: {
      type: "area",
      backgroundColor: "#E5E9EE",
      width: isMobile ? windowSize.innerWidth - 40 : windowSize.innerWidth - 500,
      height:
        isMobile ?  420
        : windowSize.innerHeight -
        toolbarHeight -
        filterContainerHeight -
        170
        //slider height
    },
    title: {
      text: undefined,
    },
    plotOptions: {
      area: {
        // pointStart: 2024,
        stacking: 'normal'
      },
    },
    credits: {
      enabled: false,
    },
    series: series,
    xAxis: {
      categories: generateYearRange(),
      allowDecimals: false,
      title: {
        text: "",
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
      labels: {
        formatter: function () {
          return xLabels.includes(this.value) ? this.value : ''; // clean, unformatted number for year
        },
        style: {
          fontFamily: "Arial",
          fontWeight: "normal",
          fontSize: "16px",
        },
      },
    },
    yAxis: {
      title: {
        text: "Colorado River Access (acre-feet)",
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
      labels: {
        formatter: function () {
          return this.value / 1000 + "k";
        },
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "14px",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#C4C4C4",
    },

    tooltip: {
      enabled: true,
      shared: true,
      crosshairs: true,
      followPointer: true,
      padding: 16,
      backgroundColor: "#FFF",
      borderRadius: 8,
      useHTML: true,
      style: {
        color: "#000",
        fontFamily: "'Arial', sans-serif",
        lineHeight: "1.5em",
      },
      formatter() {
        const year = this.x;
        let value;
        // let priority;
        let priorityName;

        if (area_chart_tab.value === 1) {
          // Area tab
          if (this.points.length !== 0 && "y" in this.points[0]) {
            value = this.points.length === 2 ? [this.points[0].y, this.points[1].y] : [this.points[0].y, 0];
          } else {
            value = [0, 0];
          }

          return `Year: <b>${year}</b><br/> 
          Total Colorado River Access amount: <b>${Math.round(
            value[0] + value[1]
          ).toLocaleString("en-US")} ac-ft</b><br />
          Central Arizona:<b> ${this.points?.length === 2 ? Math.round(
            value[0]
          ).toLocaleString("en-US") : this.points[0]?.color === '#6AA4DC' ? Math.round(
            value[0]
          ).toLocaleString("en-US") : 0} ac-ft </b><br />
          Western Arizona: <b>${this.points?.length === 2 ? Math.round(value[1]).toLocaleString(
            "en-US"
          ) : this.points[0]?.color === '#2352D0' ? Math.round(
            value[0]
          ).toLocaleString("en-US") : 0} ac-ft</b>`;
        } else {
          // Entity tab
          value = this.y;
          // priority = this.points.y;
          priorityName = this.points;

          if (isPriority === true) {
            // priority checkbox checked
            let breakdown = [];

            priorityName.map((item) => {
              breakdown.push({ value: item.y, name: item.series.name });
              return item
            });
            let string = ``;
            breakdown.map((item) => {
              string += `${item.name} : <b>${Math.round(
                item.value
              )} ac-ft</b><br/>`;
              return item
            });
            return `Year: <b>${year}</b><br/> ${string}`;
          }

          return `Year: <b>${year}</b><br/> Total: <b>${Math.round(
            value
          ).toLocaleString("en-US")} ac-ft</b>`;
        }
      },
    },
    legend: {
      itemStyle: {
        color: "#333333",
        fontSize: "14px",
        fontWeight: "normal",
        fontFamily: "Arial",
      },
      align: "center",
      verticalAlign: "bottom",
      backgroundColor: "#FFFFFF",
      borderColor: "#E0E0E0",
      borderWidth: 1,
      borderRadius: 7,
      padding: 15,
      itemMarginTop: 10,
      itemMarginBottom: 5,
      shadow: {
        offsetX: -1,
        offsetY: 3,
        color: "#00000029",
        width: 4,
      },
      x: 0,
      y: 0,
      symbolRadius: 0,
    },
    // credits: {
    //   enabled: false,
    // },
  };
};
export default AreaChart;